import { ErrorHandlingConfig } from 'shared-lib'

export const ERROR_HANDLING: ErrorHandlingConfig = {
  USER_NAME_MIN_LENGTH: 8,
  USER_NAME_MAX_LENGTH: 50,

  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 24,

  EMAIL_MIN_LENGTH: 7,
  EMAIL_MAX_LENGTH: 100,

  FIRST_NAME_MIN_LENGTH: 1,
  FIRST_NAME_MAX_LENGTH: 100,

  LAST_NAME_MIN_LENGTH: 1,
  LAST_NAME_MAX_LENGTH: 100,

  COMPANY_NAME_MIN_LENGTH: 5,
  COMPANY_NAME_MAX_LENGTH: 100,

  PHONE_MIN_LENGTH: 10,
  PHONE_MAX_LENGTH: 20,

  ADDRESS_MIN_LENGTH: 4,
  ADDRESS_MAX_LENGTH: 100,

  STATE_REQUIRED_LENGTH: 2,
  ZIP_MIN_LENGTH: 5,
  ZIP_MAX_LENGTH: 12,
  COUNTRY_REQUIRED_LENGTH: 2,
}
